export default "__VITE_PUBLIC_ASSET__2e66182e__"